import React from "react"
import styled from "styled-components"
import { useIntl } from "gatsby-plugin-react-intl"

import Link from "../Link"
import Banner from "../Banner"
import Snippet from "../Snippet"
import { media } from "../../styles"

import illustrationImage from "../../images/content/banners/wealth.svg"
import ArrowSVG from "../../images/icons/arrow-right.inline.svg"

const Container = styled.div`
  align-items: center;
  display: flex;
`

const Content = styled.div`
  padding: 15px;

  svg {
    color: ${({ theme }) => theme.sun};
  }
`

const Illustration = styled.div`
  flex: none;
  padding: 5px 0 0 15px;
  width: 100px;

  img {
    display: block;
    height: auto;
    width: 100%;
  }
`

const Header = styled.h4`
  font-size: 17px;
  font-weight: 400;
  letter-spacing: -0.1px;
  line-height: 20px;
  margin: 0;

  @media ${media.sm} {
    line-height: 23px;
    margin-bottom: 5px;
  }

  svg {
    margin-left: 5px;

    @media ${media.sm} {
      display: none;
    }
  }
`

const Text = styled.p`
  display: none;
  font-size: 12px;
  font-weight: 400;
  line-height: 16px;
  margin: 0;

  @media ${media.sm} {
    display: block;
  }

  svg {
    display: none;
    height: auto;
    margin-left: 5px;
    width: 13px;
    vertical-align: -2px;

    @media ${media.sm} {
      display: inline-block;
    }
  }
`

const WealthBanner = ({ pageId, forceLocale }) => {
  const intl = useIntl()
  const contentMap = {
    en: {
      snippet: "bannerWealth",
      width: 425,
    },
    de: {
      snippet: "bannerWealth",
      width: 535,
    },
  }

  const content = contentMap[forceLocale] || contentMap[intl.locale]

  return (
    <Banner
      id="wealth"
      pageId={pageId}
      hideOnPages={["publications/wealth-whitepaper", "survey"]}
      width={content.width}
    >
      <Link
        to={Snippet({
          id: content.snippet,
          field: "linkUrl",
        })}
        intl={false}
      >
        <Container>
          <Illustration aria-hidden="true">
            <img alt="" src={illustrationImage} height="100" width="105" />
          </Illustration>
          <Content>
            <Header>
              <Snippet id={content.snippet} field="header" />
              <ArrowSVG />
            </Header>
            <Text>
              <Snippet id={content.snippet} field="text" />
              <ArrowSVG />
            </Text>
          </Content>
        </Container>
      </Link>
    </Banner>
  )
}

export default WealthBanner
